export const ACCOUNT_DIRECTOR = "Director";

export const ACCOUNT_DIRECTOR_ID = 4;

export const ACCOUNT_AGENCY = "Agency";

export const ACCOUNT_AGENCY_ID = 2;

export const ACCOUNT_MASTER = "Master";

export const ACCOUNT_EDITOR = "Editor";

export const ACCOUNT_COS = "COS";

export const ACCOUNT_COS_ID = 7;

export const ACCOUNT_CONGRESSMAN = "Congressman";

export const ACCOUNT_CONGRESSMAN_ID = 6;

export const ACCOUNT_COMMITTEE = "Committee";

export const ACCOUNT_COMMITTEE_ID = 14;

export const ACCOUNT_HOUSE_SPEAKER = "House Speaker";

export const ACCOUNT_SUPER_ADMIN = "Super Admin";

export const ACCOUNT_OTHERS = "Others";

export const congRoles = [ACCOUNT_CONGRESSMAN, ACCOUNT_COS];

export const canEditRoles = [
  ACCOUNT_SUPER_ADMIN,
  ACCOUNT_EDITOR,
  ACCOUNT_DIRECTOR,
];

export const canAccessPage = [
  ACCOUNT_SUPER_ADMIN,
  ACCOUNT_EDITOR,
  ACCOUNT_DIRECTOR,
  ACCOUNT_AGENCY,
];

export const HIDDEN_ACCOUNTS_VIEW = [
  ACCOUNT_AGENCY,
  ACCOUNT_COS,
  ACCOUNT_COMMITTEE,
  ACCOUNT_HOUSE_SPEAKER,
];

export const COMMITTEE_VIEW = [
  ...canEditRoles,
  ACCOUNT_COMMITTEE,
  ACCOUNT_HOUSE_SPEAKER,
];

export const SUPER_ADMIN_ACCOUNTS = [
  ACCOUNT_SUPER_ADMIN,
  ACCOUNT_MASTER,
  ACCOUNT_DIRECTOR,
];

export const HIDDEN_COMMITTE_VIEW = [ACCOUNT_COMMITTEE];

export const HIDDEN_REPRESENTATIVES_VIEW = [...congRoles, ACCOUNT_COMMITTEE];

export const HIDDEN_PROGRAMS_VIEW = HIDDEN_REPRESENTATIVES_VIEW;

export const HIDDEN_AFFILIATIONS_VIEW = HIDDEN_REPRESENTATIVES_VIEW;

export const ALL_OPTION = "all";

export const REGION_PARTYLIST_ID = 18;

export const DIRECTORY_VIEW = [...canEditRoles, ACCOUNT_HOUSE_SPEAKER];

/**
 * Roles that can see the Accounts menu and access the Accounts page.
 * Intentional: Super Admin only.
 */
export const ACCOUNTS_VIEW = [ACCOUNT_SUPER_ADMIN];

export const EDITOR_SHAWN_USERNAME = "capucionshawn@gmail.com";

export const PARTYLIST = "Partylist";

export const NCR_REGION_ID = 15;

/**
 * Agency IDs that require special form handling
 * @type {number[]}
 */
export const agencyWithSpecialForms = [3, 8, 27, 14];

export const fundSourceOptions = [
  {
    label: "GAA",
    value: "GAA",
  },
  {
    label: "Unprogrammed",
    value: "Unprogrammed",
  },
];

export const institutionTypes = [
  {
    label: "Private",
    value: "Private",
  },
  {
    label: "Government",
    value: "Government",
  },
];

export const accountRoles = [
  {
    label: ACCOUNT_CONGRESSMAN,
    value: ACCOUNT_CONGRESSMAN,
  },
  {
    label: ACCOUNT_COS,
    value: ACCOUNT_COS,
  },
  {
    label: ACCOUNT_AGENCY,
    value: ACCOUNT_AGENCY,
  },
  {
    label: ACCOUNT_DIRECTOR,
    value: ACCOUNT_DIRECTOR,
  },
  {
    label: ACCOUNT_EDITOR,
    value: ACCOUNT_EDITOR,
  },
  {
    label: ACCOUNT_COMMITTEE,
    value: ACCOUNT_COMMITTEE,
  },
];

export const NINETEENTH_CONGRESS = "19th";

export const TWENTIETH_CONGRESS = "20th";

export const BEFORE_TWENTIETH = new Date("2025-07-25T00:00:00.000Z");

export const CONGRESS_OPTIONS = [
  {
    label: `${NINETEENTH_CONGRESS} Congress`,
    value: NINETEENTH_CONGRESS,
  },
  {
    label: `${TWENTIETH_CONGRESS} Congress`,
    value: TWENTIETH_CONGRESS,
  },
];

/**
 * Permissions granted to users who login via code login
 * @type {string[]}
 */
export const CODE_LOGIN_PERMISSIONS = [
  "others-view",
  "comment-view",
  "comment-create",
  "recipient-update",
];
